<template>
  <button :class="{'mobile-tab': true, 'mobile-tab-active': active}" :style="{'width': width}" @click.prevent="tabClicked">
    <slot />
    <label class="label label-primary" v-if="badge">{{badge}}</label>
  </button>
</template>

<style scoped>
.mobile-tab {
  display: inline-block;
  position: relative;
  color: #676a6c;
  height: 100%;
  padding: 0;
  font-size: 0.95rem;
  font-weight: 600;
  text-align: center;
  text-transform: uppercase;
  background-color: #ffffff;
  border: none;
}
.mobile-tab.mobile-tab-active {
  border-bottom: 4px solid #5e7c97;
  color: #272a2c;
}
.mobile-tab .label {
  position: absolute;
  top: 5px;
  right: 5px;
}
</style>


<script>
export default {
  name: 'MobileTab',
  props: {
    badge: [String, Number]
  },
  data() {
    return {
      active: false
    }
  },
  inject: {
    mobileTabbedPage: {
      default() {
        return { }
      }
    }
  },
  computed: {
    width() {
      if(this.mobileTabbedPage.registeredTabItems.length > 0)
        return Math.floor(1.0 / this.mobileTabbedPage.registeredTabItems.length * 100.0) + '%'
      return '25%'
    }
  },
  mounted() {
    this.registerTabItem()
  },
  beforeDestroy() {
    
  },
  destroyed() {
    this.unregisterTabItem()
  },
  methods: {
    registerTabItem() {
      this.mobileTabbedPage.registerTabItem && this.mobileTabbedPage.registerTabItem(this)
    },
    unregisterTabItem() {
      this.mobileTabbedPage.unregisterTabItem && this.mobileTabbedPage.unregisterTabItem(this)
    },
    tabClicked() {
      this.mobileTabbedPage.showTab(this)
      this.$emit('show')
    },
    show() {
      this.mobileTabbedPage.showTab(this)
      this.$emit('show')
    }
  }
}
</script>